export const selectSelectedFolioSeachResult = (state) =>
  state.folioSearch.selectedFolio;

export const selectFolioSearchModalActive = (state) =>
  state?.folioSearch?.modalActive;

export const selectFolioSearchBy = (state) => state?.folioSearch?.searchBy;
export const selectFolioSearchLoading = (state) => state?.folioSearch?.loading;
export const selectFolioSearchDates = (state) => state?.folioSearch?.dates;
